// removed by extract-text-webpack-plugin
module.exports = {"overlay":"hDRUY_ysc3mdhVohLfzkv","modal_content":"fP8Ew5_Tdz9zDWF4UmeYz","close_button":"sGWs28A62Aprmsrwf2B1a","modal_title":"_3vQ6vI6yiQgKHP2iGinIRK","modal_subtitle":"yLQrbmTmDkLy3OR2EMEfm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.css
// module id = 39
// module chunks = 0